import { Controller } from "@hotwired/stimulus";
import { Carousel } from "bootstrap";

export default class extends Controller {
  connect() {
    this.carousel = Carousel.getOrCreateInstance(this.element);

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.carousel.cycle();
        } else {
          this.carousel.pause();
        }
      },
      { threshold: 0 },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }
}
